<template>
<ac-modal :title="'Convert Files'" :size-class="'modal-md'" ref="excelConverter">
    <div class="row form-group">
        <div class="col-md-12 form-group">
            <p class="form-group">
                This tool converts files back and forth between either an Excel or 834 file type. 
                Simply select the file that you want to convert below.
                Then click the "Convert" button and it will be downloaded to your machine as the opposite file type.
            <p>
            <label class="company-label">
                Select A File To Convert
            </label>
            <div class="input-group" id="csv-selector-container">
                <label class="input-group-btn">
                    <span class="btn btn-blue btn-sm btn-file" style="border-top-width: 4px; border-bottom-width: 3px"
                        title="Click to select an Excel file from your computer to upload.">
                        Browse&hellip; <input ref="uploader" type="file" style="display: none;" @change="fileSelected">
                    </span>
                </label>
                <input type="text" class="form-control col-8" readonly v-model="fileName">
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <ac-button type="button" style="margin-left: 10px" class="btn btn-green btn-sm pull-right"
                    title="Click to convert to either Excel or 834"
                    :action="uploadFile">
                <i class="fa fa-lg fa-download"></i> CONVERT FILE
            </ac-button>
            <ac-button type="button" style="margin-left: 10px" class="btn btn-red btn-sm pull-right"
                    title="Click to remove the file previously selected using the 'Browse' button."
                    :action="closeModal">
                CANCEL
            </ac-button>
        </div>
    </div>
</ac-modal>
</template>

<script>
import {notifications} from "../../../../global/notifications.js";
import {common} from "../../../../global/common.js";
import {api} from "../../../../global/framework/api.js";

export default {
    data() {
        return {
            companyId: null,
            companyFiles: null,
            spreadsheet: null,
            fileName: "",
        }
    },
    methods: {
        async showModal(companyId) {
            this.companyId = companyId;
            this.$refs.excelConverter.open();
        },
        closeModal() {
            this.clearFile();
            this.$refs.excelConverter.close();
        },
        async uploadFile() {
            if (this.spreadsheet == null) {
                notifications.show({
                    title: "Error",
                    message: "You need to select a file first"
                }, common.ACRESSA_NOTIFICATIONS.ERROR);
                return;
            } 
            
            let formData = new FormData();
            formData.append("employeeFile", this.spreadsheet);

            if (this.fileExt == '.xlsx') {
                common.downloadFile(`Admin/DownloadExcelAsEdiFile`, `${this.fileName}.txt`, formData, true);
            }
            else if (this.fileExt == '.txt') {
                common.downloadFile(`Admin/DownloadEdiAsExcelFile`, `${this.fileName}.xlsx`, formData, true);
            }

            this.clearFile();
            this.closeModal();
        },
        clearFile() {
            this.spreadsheet = null;
            this.fileName = "";
            this.$refs.uploader.value = null;
        },
        fileSelected(event) {
            this.spreadsheet = null;
            let fileData = event.target.files[0];

            if (fileData) {
                this.spreadsheet = fileData;
                this.fileName = fileData.name;
                this.fileExt = this.fileName.substring(this.fileName.lastIndexOf('.'));

                if (this.fileExt !== '.xlsx' && this.fileExt !== '.txt') {
                    notifications.show({
                        title: "Error",
                        message: "Only xlsx and txt files types are allowed."
                    }, common.ACRESSA_NOTIFICATIONS.ERROR);
                    this.clearFile();
                }
            }
        },
    },
}
</script>
